export enum ModalState {
  active = 'active',
  expiringSoon = 'expiring',
  expiredStillAvailable = 'expired-unreserved',
  expiredUnavailable = 'expired-reserved',
}
